module.exports = __webpack_public_path__ + "static/media/hat-cowboy-side.9c197555.svg";